import React from 'react';
import Checkbox from 'material-ui/Checkbox';

export default props => (
  <Checkbox
    {...props.inputProps}
    {...props.input}
    checked= {props.input.value ? true : false}
    onCheck={(event, isInputChecked) => {
      props.input.onChange(isInputChecked);
      if (props.inputProps && props.inputProps.onCheck) {
        props.inputProps.onCheck(isInputChecked);
      }
    }}
  />
);



// WEBPACK FOOTER //
// src/modules/forms/components/CheckBoxField.js